/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Kbd_NavigateInputs */

const en_us2_search_kbd_navigate = /** @type {(inputs: Search_Kbd_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`navigate`)
};

const pt_br2_search_kbd_navigate = /** @type {(inputs: Search_Kbd_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`navegar`)
};

const es_419_search_kbd_navigate = /** @type {(inputs: Search_Kbd_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`navegar`)
};

const pt_pt2_search_kbd_navigate = /** @type {(inputs: Search_Kbd_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`navegar`)
};

const fr_fr2_search_kbd_navigate = /** @type {(inputs: Search_Kbd_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`naviguer`)
};

const de_de2_search_kbd_navigate = /** @type {(inputs: Search_Kbd_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`navigieren`)
};

const it_it2_search_kbd_navigate = /** @type {(inputs: Search_Kbd_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`naviga`)
};

/**
* | output |
* | --- |
* | "navigate" |
*
* @param {Search_Kbd_NavigateInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_kbd_navigate = /** @type {((inputs?: Search_Kbd_NavigateInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Kbd_NavigateInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_kbd_navigate(inputs)
	if (locale === "es-419") return es_419_search_kbd_navigate(inputs)
	if (locale === "pt-PT") return pt_pt2_search_kbd_navigate(inputs)
	if (locale === "fr-FR") return fr_fr2_search_kbd_navigate(inputs)
	if (locale === "de-DE") return de_de2_search_kbd_navigate(inputs)
	if (locale === "it-IT") return it_it2_search_kbd_navigate(inputs)
	return en_us2_search_kbd_navigate(inputs)
});
export { search_kbd_navigate as "search.kbd_navigate" }